<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="crudForm" @submit.prevent="submit">
        <v-row>
          <v-col cols="12">
            <v-text-field label="Tag Name"
                          v-model="model.Title"
                          :rules="rules.Title" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn type="submit" color="primary" :loading="loading">
              {{ id ? 'Save' : 'Create' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { rules } from '@/util/Helpers';

export default {
  name: 'TagForm',
  props: {
    Id: [String, Number],
    Title: String,
  },
  data() {
    return {
      id: this.Id,
      model: {
        Title: this.Title,
      },
      rules: {
        Title: [
          (v) => rules.required(v, 'Please enter a Tag Name'),
        ],
      },
      loading: false,
    };
  },
  methods: {
    submit() {
      if (this.$refs.crudForm.validate()) {
        this.loading = true;
        if (this.id) {
          this.update();
        } else {
          this.create();
        }
        this.loading = false;
      }
    },
    async create() {
      try {
        const response = await this.$store.dispatch('post', {
          api: 'Tag',
          data: this.model,
        });
        this.$emit('snackbar', 'Tag successfully created!');
        this.id = response.data.Id;
      } catch (e) {
        // Do nothing
      }
    },
    async update() {
      try {
        await this.$store.dispatch('put', {
          api: `Tag/${this.id}`,
          data: this.model,
        });
        this.$emit('snackbar', 'Tag successfully updated!');
      } catch (e) {
        // Do nothing
      }
    },
  },
};
</script>
